<template>
    <div id="room-strip" class="tri-bg">
      
        <div class="container room-service">
            <div class="row">
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-bed-12"><img :src="iconBed"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">飯店御用床墊</div>
                    <div class="room-service-desc">舒適的睡床，採用旅館等級優質好床－天妮絲獨立筒床墊(TENLLis Bed)與寢具，創造最健康舒適的舒眠環境，讓旅人一夜好眠</div>
                </div>
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-bathtub2"><img :src="iconBathtub"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">​浴缸淋浴設備</div>
                    <div class="room-service-desc">有完整的淋浴間和獨立浴缸，讓您在結束一整天的旅程後，可以進行一場身心靈的放鬆。（依房型）</div>
                </div>
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-bathtub2"><img :src="iconMinibar"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">​零食飲料MiniBar</div>
                    <div class="room-service-desc">客房內設有免費MiniBar，提供茶包、濾掛咖啡、零食及各式飲料，讓您在放鬆的同時，也能同時品嘗解饞小品。</div>
                </div>
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-cutlery-1"><img :src="iconBreakfast"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">​美味經典早餐</div>
                    <div class="room-service-desc">提供現做豐盛的早餐套餐，滿足最重視早餐的您，每位旅客皆可於Sunshine Café中享用您美味的早餐時光，開啟活力的一天。（視訂房方案）</div>
                </div>
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-wifi2"><img :src="iconWifi"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">​無線網路服務</div>
                    <div class="room-service-desc">全區提供免費無線網路上網，帶給旅客最新科技的便利環境，旅遊途中也不遺漏任何關心的資訊。</div>
                </div>
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-map"><img :src="iconMap"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">必玩旅遊地圖</div>
                    <div class="room-service-desc">各種旅遊景點及交通指南，讓您快速熟悉整個台東，貼近在地生活的脈動。</div>
                </div>
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-cutlery-1"><img :src="iconDrink"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">付費下午茶酒吧</div>
                    <div class="room-service-desc">午後時光，於 Sunshine Café 享受慵懶的海灣下午茶(視情況提供、預約制)。夜晚轉身，來杯在地調酒，恣意放鬆身心靈。（暫不提供）</div>
                </div>
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-wifi2"><img :src="iconActivity"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">付費體驗活動</div>
                    <div class="room-service-desc">深入瘋玩台東海岸秘境，以民宿優惠價格體驗在地活動，如海上SUP，用不同視角划進台東每一處角落(預約制)。</div>
                </div>
                <div class="col-12 col-sm-12 col col-md-4 room-service-item" data-aos="zoom-in">
                    <div class="icon-map"><img :src="iconRent"/></div>
                    <div class="short-line"></div>
                    <div class="room-service-title">特約租車合作</div>
                    <div class="room-service-desc">玩遍各處台東景點，便利的交通工具是重要的一環，民宿配合租車公司提供專屬價格，住行一次搞定。</div>
                </div>
            </div>
        </div>
        <div class="room-intro">
            <div class="romm-intro-slider">
            <swiper :options="swiperOption" class="d-none d-md-block swiper-desktop">
                <swiper-slide v-for="(banner, $index) in banners" :key="$index"><img style="width: 100%;height: 100%;" :src="pathheader + '//rich-sunshine.tw/sources/' + banner.image_path_after + '/' + banner.image + '.jpg'" :alt="banner.title"></swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <swiper :options="swiperOptionMobile" class="d-md-none swiper-mobile">
                <swiper-slide v-for="(banner, $index) in banners" :key="$index"><progressive-img style="width: 100%;height: 100%;" :src="pathheader + '//rich-sunshine.tw/sources/' + banner.image_path_after + '/' + banner.image + '.jpg'" :alt="banner.title"></progressive-img></swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import iconMap from '@/assets/icons/map.svg'
import iconWifi from '@/assets/icons/wifi.svg'
import iconBed from '@/assets/icons/bed.svg'
import iconBathtub from '@/assets/icons/bathtub.svg'
import iconBreakfast from '@/assets/icons/cutlery.svg'
import iconMinibar from '@/assets/icons/minibar.svg'
import iconDrink from '@/assets/icons/winebottle.svg'
import iconActivity from '@/assets/icons/sunumbrella.svg'
import iconRent from '@/assets/icons/taxi.svg'

const pathheader = window.location.protocol

export default {
  name: 'inex-room',
  components: {},
  data () {
    return {
      pathheader: pathheader,
      banners: [],
      swiperOption: {
        // pagination: '.swiper-pagination',
        slidesPerView: 3,
        slidesPerColumn: 3,
        paginationClickable: true,
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination'
        },
        onClick (swiper, event) {
            // console.log('Swiper-onClick.activePageIndex:', swiper.activeIndex)
            // console.log('Swiper-onClick.current Page activeItemIndex:', swiper.clickedIndex)
        }
      },
      swiperOptionMobile: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        }
      }
    }
  },
  computed: {
    iconMap () {
      return iconMap
    },
    iconBathtub () {
      return iconBathtub
    },
    iconBed () {
      return iconBed
    },
    iconWifi () {
      return iconWifi
    },
    iconMinibar () {
      return iconMinibar
    },
    iconBreakfast () {
      return iconBreakfast
    },
    iconDrink () {
      return iconDrink
    },
    iconActivity () {
      return iconActivity
    },
    iconRent () {
      return iconRent
    }
  },
  mounted () {
    this.getMainData()
  },
  methods: {
    getMainData () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getOtherSlider', {withCredentials: true})
      .then((response) => {
        // console.log(response)
        const res = response.data
        this.banners = res.data.map(d => {
          return {...d, image_path_after: (d.image_path === 'want2go' ? d.image_path : ('room/' + d.image_path))}
        })
      })
      .catch((errorResponse) => {
        // console.log(errorResponse)
      })
    }
  }
}
</script>
<style lang="scss">
#room-strip {
    background-color: white;
    padding-top: 100px;
    padding-bottom: 100px;
    position: relative;
    &:before {
        content: '';
        position: absolute;
        top: -25px;
        border-bottom: 25px white solid;
        border-right: 25px rgba(0,0,0,0) solid;
        border-left: 25px rgba(0,0,0,0) solid;
        left: 50%;
        margin-left: -25px;
    }
    // &.tri-bg {
        // width: 100vw;
        // height: 400px;
        // background: linear-gradient(30deg, rgba(255, 255, 255, .5)45%, rgba(255, 255, 255, 1)45%), linear-gradient(-30deg, rgba(235, 140, 90, 1)45%, rgba(255, 255, 255, 1)45%);
        // background: -webkit-linear-gradient(30deg, rgba(255, 255, 255, .5)45%, rgba(255, 255, 255, 1)45%), -webkit-linear-gradient(-30deg, rgba(235, 140, 90, 1)45%, rgba(255, 255, 255, 1)45%);
        // background: -o-linear-gradient(30deg, rgba(255, 255, 255, .5)45%, rgba(255, 255, 255, 1)45%), -o-linear-gradient(-30deg, rgba(235, 140, 90, 1)45%, rgba(255, 255, 255, 1)45%);
    // }
    .room-title {
        font-weight: 600;
        letter-spacing: 1.6px;
        // color: #F4EAB1;
        letter-spacing: 10px;
        margin-bottom: 5rem;
    }
    .circle_button_text {
      font-weight: 100;
      text-align: center;
      letter-spacing: 2px;
      text-align: center;
      background: #000;
      color: white;
      vertical-align: middle;
      cursor: pointer;
      overflow: hidden;
      transition: color 1s, background 1s;
      padding: 20px;
      &:hover {
        background: #55b3ac;
        color: #fff;
      }
      span {
        font-size: 18px;
        text-transform: uppercase;
      }
    }
    .room-service {
        // padding-top: 100px;
        padding-bottom: 50px;
        .row .col {
            margin-bottom: 3rem;
        }
        .room-service-item:hover {
           [class^="icon-"] {
               transition: .5s ease-in-out;
                color: rgba(235, 125, 89, 0.72);
            } 
            .room-service-title {
                transition: .5s ease-in-out;
                color: rgba(235, 125, 89, 0.72);
            }
        }
        [class^="icon-"] {
            font-size: 96px;
            // color: #F4EAB1;
        }
        .room-service-item img {
            width: 60%;
        }
        .room-service-title {
            // color: #F4EAB1;
            font-size: 19px;
            letter-spacing: 3px;
            margin-top: 20px;
        }
        .room-service-desc {
            font-weight: 100;
        }
        .short-line {
            display: none;
            width: 20px;
            height: 2px;
            background-color: #F4EAB1;
            margin: 20px auto;
        }
    }

}
</style>




// WEBPACK FOOTER //
// src/components/IndexService.vue